import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPeepRelatedLeadStats as GetPeepRelatedLeadStatsQuery,
    GetPeepRelatedLeadStatsVariables as GetPeepRelatedLeadStatsQueryVariables,
} from 'nutshell-graphql-types';

import GET_PEEP_RELATED_LEAD_STATS from '../../graphql/queries/get-peep-related-lead-stats.graphql';

export const useGetPeepRelatedLeadStats = (id: string) => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetPeepRelatedLeadStatsQuery, GetPeepRelatedLeadStatsQueryVariables>(
        GET_PEEP_RELATED_LEAD_STATS,
        {
            variables: {id},
            fetchPolicy: 'cache-and-network',
        }
    );

    const {peep} = makeDataDangerous(data);

    return {
        isLoading,
        peep: peep,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
